import { render, staticRenderFns } from "./languageswitcher.vue?vue&type=template&id=2d94112c&scoped=true"
import script from "./languageswitcher.vue?vue&type=script&lang=js"
export * from "./languageswitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d94112c",
  null
  
)

export default component.exports